import { typedQueryClient, useTypedQuery } from "hooks";
import { LANGUAGE_OPTIONS } from "modules/NewsDashboard/hooks/useLanguageOptions";
import { NewsQueryKeys } from "modules/NewsDashboard/queryKeys";
import { NEWS_STORAGE_KEYS } from "modules/NewsDashboard/storageKeys";
import { PAGE_SIZE, getPreference } from "utils/common";

import type { NewsFilters } from "modules/NewsDashboard/queryKeys";

export const useNewsFilters = () =>
  useTypedQuery({
    queryKey: NewsQueryKeys.newsFilters,
    initialData: {
      page: 1,
      search_term: null,
      dealer_ids: getPreference(NEWS_STORAGE_KEYS.DealerPreference, null),
      category_ids: getPreference(NEWS_STORAGE_KEYS.CategoryPreference, null),
      published_date: getPreference(NEWS_STORAGE_KEYS.PublishedDatePreference, null),
      page_size: getPreference(NEWS_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize50),
      language_code: getPreference(NEWS_STORAGE_KEYS.LanguagePreference, LANGUAGE_OPTIONS.All)
    }
  }).data;

export const setNewsFilters = (updatedFilters: NewsFilters) => {
  const currentFilters = typedQueryClient.getQueryData(NewsQueryKeys.newsFilters);
  typedQueryClient.setQueryData(NewsQueryKeys.newsFilters, { ...currentFilters, ...updatedFilters });
};
